import { BrowserModule } from "@angular/platform-browser";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { AppComponent } from "./app.component";
import { RoutingModule } from "./routing.module";
import { EnsureAuthenticated } from "./modules/shared/services/ensure-authenticated.service";
import { LoginRedirect } from "./modules/shared/services/login-redirect.service";
import { AuthService } from "./modules/shared/services/auth.service";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "./modules/shared/shared.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AlertModule } from "ngx-bootstrap/alert";
import { ToastrModule } from "ngx-toastr";

@NgModule({
  declarations: [AppComponent],

  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RoutingModule,
    HttpClientModule,
    SharedModule.forRoot(),
    AlertModule.forRoot(),
    ToastrModule.forRoot({ positionClass: "toast-top-center" }),
  ],
  providers: [EnsureAuthenticated, LoginRedirect, AuthService],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
